import axios from 'axios';
import {REQUEST_URL} from '../config/urls';

const requisitar = () => {
  return {
    type: "REQUISITAR_ACAO"
  };
}

const novaAcao = (acao) => {
  return {
    type: "NOVA_ACAO",
    acao
  }
}
const obterAcoesContrato = (acoes) => {
  return {
    type: "OBTER_ACOES_CONTRATO",
    acoes
  }
}
const obterAcoesAtor = (acoes) => {
  return {
    type: "OBTER_ACOES_ATOR",
    acoes
  }
}
const alterarAcao = (acao) =>{
  return {
    type: "VISUALIZAR_ACAO",
    acao
  }
}
const obterAcoesAtorNV = (acoes,type) => {
  return {
    type: type,
    acoes
  }
}
const erro = (erro) => {
  if (erro && erro.response && erro.response.data && erro.response.data.error && erro.response.data.error.statusCode === 401) {
    axios.defaults.headers.common['Authorization'] = "";
    return {
      type: "LOGOUT"
    }
  }
  return {
    type: "ERRO_ACAO",
    erro
  }
}

export const cadastrarAcao = (acao) => {
  return dispatch => {
    dispatch(requisitar());
    return axios.post(`${REQUEST_URL}/acoes`, acao).then((response) => {
      dispatch(novaAcao(response.data));
    }).catch(error => {
      dispatch(erro(error));
    });
  }
}
export const obterAcoesDoContrato = (contratoId) =>{
  return dispatch =>{
    dispatch(requisitar());
    return axios.get(`${REQUEST_URL}/acoes?filter={"where":{"contrato":${contratoId}}, "order": ["data DESC"]}`).then((response) => {
      dispatch(obterAcoesContrato(response.data));
    }).catch(error => {
      dispatch(erro(error));
    });
  }
}
export const obterAcoesDoAtor = (atorId) =>{
  return dispatch =>{
    dispatch(requisitar());
    return axios.get(`${REQUEST_URL}/acoes?filter={"where":{"ator":${atorId}}}`).then((response) => {
      dispatch(obterAcoesAtor(response.data));
    }).catch(error => {
      dispatch(erro(error));
    });
  }
}
export const obterAcoesDoAtorNaoVisualizadas = (atorId) =>{
  return dispatch =>{
    dispatch(requisitar());
    let filter ="";
    if(atorId !== null){
      filter = `{"where":{"ator":${atorId}, "visualizado":false}}`;
    }else{
      filter = `{"where":{"visualizado":false}}`;
    }
    return axios.get(`${REQUEST_URL}/acoes?filter=${filter}`).then((response) => {
      dispatch(obterAcoesAtor(response.data));
    }).catch(error => {
      dispatch(erro(error));
    });
  }
}

export const obterAcoesDoAtorNaoVisualizado = (atorId, tipo) =>{
  let type ="";
  switch (tipo) {
    case "notificacao":
      type = "OBTER_ACOES_ATOR_NV";
      break;
    case "atrazado":
      type = "OBTER_ACOES_ATOR_NV_ATRAZO";
      break;
    case "finalizado":
      type = "OBTER_ACOES_ATOR_NV_FINALIZADOS";
      break;
    case "comissao":
      type = "OBTER_ACOES_ATOR_NV_COMISSAO";
      break;
    default:
  }
  return dispatch =>{
    dispatch(requisitar());
    let filter ="";
    if(atorId !== null){
      filter = `{"where":{"ator":${atorId}, "visualizado":false ,"tipo":"${tipo}"}}`;
    }else{
      filter = `{"where":{"visualizado":false ,"tipo":"${tipo}"}}`;
    }
    return axios.get(`${REQUEST_URL}/acoes?filter=${filter}`).then((response) => {
      dispatch(obterAcoesAtorNV(response.data, type));
    }).catch(error => {
      dispatch(erro(error));
    });
  }
}
export const obterAcoesNaoVisualizado = (tipo) =>{
  return dispatch =>{
    dispatch(requisitar());
    return axios.get(`${REQUEST_URL}/acoes?filter={"where":{"visualizado":false ,"tipo":${tipo}}}`).then((response) => {
      dispatch(obterAcoesAtorNV(response.data));
    }).catch(error => {
      dispatch(erro(error));
    });
  }
}

export const visualizarAção = (id) => {
  let acao ={
    visualizado:true
  }
  return dispatch => {
    dispatch(requisitar());
      return axios.patch(`${REQUEST_URL}/acoes/${id}`, acao).then((response) => {
        dispatch(alterarAcao(response.data));
      }).catch(error => {
        dispatch(erro(error));
      });
  }
}



// WEBPACK FOOTER //
// ./src/actions/AcaoActions.js